export const UPDATE_WISH_LIST = "UPDATE_WISH_LIST";
